import { Box, Typography, Grid, Paper } from "@mui/material";
// import PanelButton from "./PanelButton";
import SearchText from "./SearchText";
// import SortButton from "./SortButton";
import CartButton from "./CartButton";
import QuantityControl from "./QuantityControl";
import { CountCustomerProduct } from "../types/customerProduct";
import { useAuthContext } from "../auth/AuthContext";

export default function Orderlist() {
  // const [activeButton, setActiveButton] = useState<'all' | 'usual'>('all');
  // const [isAscending, ] = useState<boolean>(true);
  // const toggleSortOrder = () => { setIsAscending(!isAscending) };
  const { state, dispatch } = useAuthContext();

  const updateProductCount = (index: number, count: number) => {
    dispatch({
      type: 'UPDATE_PRODUCT',
      payload: { index, count, is_display: count >= 0 }
    });
  };

  const handleSetUpdatedProducts = (updatedProducts: CountCustomerProduct[]) => {
    updatedProducts.forEach((product, index) => {
      dispatch({
        type: 'UPDATE_PRODUCT',
        payload: { index, count: product.count, is_display: product.is_display }
      });
    });
  };

  return (
    <Box sx={{ padding: 2 }}>
      {/* TODO:いつものリストの実装 */}
      {/* <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Box sx={{ display: "flex", gap: 0 }}>
          <PanelButton isActive={activeButton === 'all'} onClick={() => setActiveButton('all')}>
            すべての商品
          </PanelButton>
          <PanelButton isActive={activeButton === 'usual'} onClick={() => setActiveButton('usual')}>
            いつものリスト
          </PanelButton>
        </Box>
      </Box> */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 12 }}>
      <SearchText products={state.products} setUpdatedProducts={handleSetUpdatedProducts}/>
        {/* TODO:ソート機能は後日 */}
        {/* <SortButton isAscending={isAscending} toggleSortOrder={toggleSortOrder} /> */}
      </Box>
      <Grid container spacing={0}>
      {state.products.map((product: CountCustomerProduct, index: number) => (
          <Grid item xs={12} key={index}>
            {product.is_display ? (
              <Paper sx={{ display: "flex", alignItems: "center", p: 2, mb: 1 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">{product.product_name} </Typography>
                  <Typography variant="body2" color="textSecondary">
                    1{product.product_unit} {product.price}円 (税込)
                  </Typography>
                </Box>
                <QuantityControl
                  index={index}
                  quantity={product.count}
                  handleQuantityChange={updateProductCount}
                />
              </Paper>
            ) : null}
          </Grid>
      ))}
      </Grid>
      <CartButton/>
    </Box>
  );
}
